import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeToast } from "store/slices/toast.slice";
import { Alert, Snackbar, Slide, LinearProgress } from "@mui/material";
import MuiTypography from "../MuiTypography";
import MuiBox from "../MuiBox";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const ToastWrapper = ({ time = 4000 }) => {
  const dispatch = useDispatch();
  const { isOpen, message, type } = useSelector((state) => state.toast);
  const timeoutRef = useRef();
  const toastColorRef = useRef("#171717");
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    dispatch(closeToast());
  };

  useEffect(() => {
    if (isOpen) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        dispatch(closeToast());
      }, time);
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isOpen, message, type, time, dispatch]);
  if (isOpen) {
    toastColorRef.current =
      type === "error" ? "#E12121" : type === "info" ? "#5cb85c" : "#171717";
  }

const toastColor = toastColorRef.current;
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={isOpen}
      onClose={handleClose}
      TransitionComponent={SlideTransition}
      sx={{
        zIndex: 99999,
        mt: "2rem",
        "& .MuiAlert-message": {
          padding: "0 !important",
        },
        "& .MuiAlert-action": {
          padding: "0 0 0 16px !important",
          color: "#fff !important",
        },
        "& .MuiPaper-root": {
          backgroundColor: toastColor,
          padding: "12px 16px !important",
          alignItems: "flex-start",
        },
        overflow: "hidden",
        borderRadius: "12px",
      }}
    >
      <Alert icon={false} type={type} onClose={handleClose}>
        <MuiBox
          sx={{
            bgcolor:
              type === "error"
                ? " #E12121"
                : type === "info"
                  ? "#5cb85c"
                  : "#171717",
          }}
        >
          <LinearProgress
            variant={"determinate"}
            value={100}
            sx={{
              color:
                type === "error"
                  ? " #E12121"
                  : type === "info"
                    ? "#5cb85c"
                    : "#171717",
              "& .MuiLinearProgress-bar": {
                backgroundColor:
                  type === "error"
                    ? " #E12121 !important"
                    : type === "info"
                      ? "#5cb85c !important"
                      : "#171717 !important",
              },
            }}
          />
        </MuiBox>
        <MuiTypography
          sx={{
            color: "text.white",
            maxWidth: "270px",
          }}
          variant="body2"
          fontWeight={"600"}
        >
          {message}
        </MuiTypography>
      </Alert>
    </Snackbar>
  );
};

export default ToastWrapper;
